import { useMutation as a, useQueryClient as p } from "@tanstack/react-query";
import c from "./subscription.api.js";
import { teachurKeys as l } from "../../constants/teachurKeys.js";
const C = (o) => a({
  mutationFn: async (r) => {
    const e = await c.checkCoupon(r), { coupon: n, code: t, newPrice: s, newMonthlyPrice: u } = e.data, i = n ?? t;
    return {
      valid: !!(i != null && i.valid),
      newPrice: s,
      newMonthlyPrice: u
    };
  },
  meta: {
    errorMessage: "Failed to validate coupon"
  },
  ...o
}), M = (o) => {
  const r = p(), { onSuccess: e, ...n } = o ?? {};
  return a({
    mutationFn: async (t) => (await c.createSubscription(t)).data,
    onSuccess: (t, s, u) => {
      r.invalidateQueries({ queryKey: l.users.currentUser() }), e == null || e(t, s, u);
    },
    meta: {
      successMessage: "You successfully subscribed!",
      errorMessage: "Subscription failed"
    },
    ...n
  });
};
export {
  C as useCheckCouponMutation,
  M as useCreateSubscriptionMutation
};
